import React from 'react';
import { connect } from 'react-redux';
import { Router, Route, Switch } from 'react-router-dom';
import createHistory from 'history/createBrowserHistory';

import { logout, tempLogin, validateAuth } from '../actions/authActions';
import PrivateRoute from './PrivateRoute';
import PrivateAdminRoute from './PrivateAdminRoute';
import PrivateAdminLiaisonRoute from './PrivateAdminLiaisonRoute';
import PublicRoute from './PublicRoute';
import HomePage from '../components/pages/HomePage';
import LoginPage from '../components/pages/LoginPage';
import RedirectPage from '../components/pages/RedirectPage';
import NotFoundPage from '../components/pages/NotFoundPage';
import ProfileListPageLoadable from '../components/pages/ProfileListPageLoadable';
import DashboardPageLoadable from '../components/pages/DashboardPageLoadable';
import LiaisonListPageLoadable from '../components/pages/LiasonListPageLoadable';
import LiaisonDetailPageLoadable from '../components/pages/LiaisonDetailPageLoadable';
import ProfileDetailPageLoadable from '../components/pages/ProfileDetailPageLoadable';
import '../../public/assets/img/sprites.svg';


export const history = createHistory();

class AppRouter extends React.Component {
  componentWillMount() {
    if (history.location.pathname === '/logout') {
      this.props.logout();
    } else {
      this.props.tempLogin();
      this.props.validateAuth();
    }
    ProfileListPageLoadable.preload();
    DashboardPageLoadable.preload();
    LiaisonListPageLoadable.preload();
    LiaisonDetailPageLoadable.preload();
    ProfileDetailPageLoadable.preload();
  }
  render() {
    return (
      <Router history={history} >
        <div>
          <Switch>
            <PublicRoute path="/" component={HomePage} exact={true} />
            <PublicRoute path="/admin" component={LoginPage} exact={true} />
            <PublicRoute path="/redirect" component={RedirectPage} exact={true} />
            <PrivateRoute path="/dashboard" component={DashboardPageLoadable} exact={true} />
            <PrivateAdminLiaisonRoute path="/dashboard/:id" component={DashboardPageLoadable} />
            <PrivateAdminRoute path="/liaisons" component={LiaisonListPageLoadable} exact={true} />
            <PrivateAdminRoute path="/liaisons/new" component={LiaisonDetailPageLoadable} />
            <PrivateAdminRoute path="/liaisons/:id" component={LiaisonDetailPageLoadable} />
            <PrivateAdminLiaisonRoute path="/profiles" component={ProfileListPageLoadable} exact={true} />
            <PrivateRoute path="/profiles/:id" component={ProfileDetailPageLoadable} />
            <Route component={NotFoundPage} />
          </Switch>
        </div>
      </Router>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    logout: () => dispatch(logout()),
    tempLogin: () => dispatch(tempLogin()),
    validateAuth: token => dispatch(validateAuth(token))
  };
};

export default connect(undefined, mapDispatchToProps)(AppRouter);



// WEBPACK FOOTER //
// ./src/routers/AppRouter.jsx